
export const FETCH_USER = 'FETCH_USER';
export const FETCH_ERROR = 'FETCH_ERROR';
export const SET_LOADER = 'SET_LOADER';
export const SET_VARIANT_ANSWERS = 'SET_VARIANT_ANSWERS';
export const GET_ALL_VARIANTS_ANSWERS = 'GET_ALL_VARIANTS_ANSWERS';
export const SET_TOKEN = 'SET_TOKEN';